import { useState } from "react";
import { TreeDeciduous, Mountain, Waves, Flame, Flower2, ArrowRight } from "lucide-react";
import { SESSIONS } from "@/data";
import { Reveal, LeafDivider } from "@/components/Reveal";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";

const ICONS = { TreeDeciduous, Mountain, Waves, Flame, Flower2 };

export const Sessions = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="workshops" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="text-center mb-14">
          <LeafDivider label="Verankerpunten" />
          <h2 className="font-display text-4xl sm:text-5xl text-brand-forest mt-3">De vijf verankersessies</h2>
          <p className="font-body text-brand-inkSoft max-w-xl mx-auto mt-4 text-lg">
            Vijf ankerpunten, vijf wegen naar binnen. Elke sessie nodigt je uit om te verankeren in rust, kracht, verstilling, transformatie en liefde.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {SESSIONS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.id} delay={i * 0.1}>
                <article className="card-soft rounded-2xl overflow-hidden h-full flex flex-col group" data-testid={`session-card-${s.id}`}>
                  <div className="relative h-44 overflow-hidden">
                    <img src={s.image} alt={s.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                    <span className="absolute -bottom-5 left-1/2 -translate-x-1/2 grid place-items-center w-12 h-12 rounded-full bg-brand-paper border border-brand-gold/40 text-brand-sage shadow">
                      <Icon size={22} strokeWidth={1.5} />
                    </span>
                  </div>
                  <div className="px-5 pt-9 pb-6 flex flex-col flex-1 text-center">
                    <h3 className="font-display text-2xl text-brand-forest tracking-[0.1em]">{s.name}</h3>
                    <p className="font-body text-sm text-brand-inkSoft mt-3 flex-1 leading-relaxed">{s.short}</p>
                    <button
                      data-testid={`session-more-${s.id}`}
                      onClick={() => setActive(s)}
                      className="mt-5 inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-brand-sage/15 text-brand-forest text-xs uppercase tracking-[0.15em] font-body transition-all hover:bg-brand-sage hover:text-white"
                    >
                      Meer over {s.name.toLowerCase()} <ArrowRight size={14} />
                    </button>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="bg-brand-paper border-brand-gold/30 max-w-lg" data-testid="session-dialog">
          {active && (
            <>
              <img src={active.image} alt={active.name} className="w-full h-48 object-cover rounded-xl" />
              <DialogHeader>
                <DialogTitle className="font-display text-3xl text-brand-forest tracking-[0.08em]">{active.name}</DialogTitle>
                <DialogDescription className="font-body text-brand-ink text-base leading-relaxed pt-2">
                  {active.long}
                </DialogDescription>
              </DialogHeader>
              <a href="#contact" onClick={() => setActive(null)} data-testid="session-dialog-contact" className="mt-2 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-brand-forest text-brand-cream text-xs uppercase tracking-[0.15em]">
                Plan deze sessie <ArrowRight size={14} />
              </a>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
